<div *ngIf="!mostrarFormulario">
  <app-lfsa-card [innTemplate]="carga" [titulo]="titulo" [efecto]="true" [colapseName]="'carga'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #carga>
    <form [formGroup]="formulario" novalidate class="form-group">
      <div class="row">
        <div class="form-group col-md-4">
          <app-lfsa-combo-box-mult [mostrarImg]="false" [multiple]="false" [rutaImagen]="" (enviarOjeto)="obtenerObjetoDistribuidor($event)"
                [placeholder]="'Distribuidor'" [opcion]="'descripcion'" [idOpcion]="'idDistribuidor'" [comboBox]="cmbDistribuidor"
                [class]="'letrasDanger'" [label]="'Seleccione Distribuidor*'" [id]="'Distribuidor'">
          </app-lfsa-combo-box-mult>
        </div>
        <div class="form-group col-md-4">
          <img *ngIf="true" [src]="csv" height="35" width="35" alt="">&nbsp;
          <label for="csvInput" class="letrasDanger">{{ titulo }}.csv*</label>
          <input type="file" class="form-control-file" id="csvInput" (change)="onFileSelect($event)" #fileInput
            accept=".csv" />
        </div>
        <div class="form-group col-md-4">
          <label for="">&nbsp;</label>
          <button [disabled]="formulario.invalid" (click)="enviarFormulario()"
            class="zatras btn btn-success btn-block">Enviar</button>
        </div>
      </div>
    </form>
    <br>
    <div class="row">
      <ag-grid-angular [floatingFilter]="true" *ngIf="!listaVaciaCli" class="{{distribuidorModulo.agGrid.class}}" #agGrid
        [ngStyle]="distribuidorModulo.agGrid.style" id="{{distribuidorModulo.agGrid.id}}"
        [paginationPageSize]="distribuidorModulo.agGrid.paginacion" [pagination]="true"
        [frameworkComponents]="frameworkComponentsCli" [columnDefs]="columnDefsCli" [rowSelection]="rowSelectionCli"
        [rowData]="rowDataCli" (gridReady)="onGridReadyCli($event)">
      </ag-grid-angular>
    </div>
    <br>
    <br>
    <br>
  </ng-template>
  <!-- <div class="row">
    <div class="form-group col-md-12">
      <div *ngIf="formulario.invalid" class="zatras alert alert-danger" role="alert">
        <b> Complete la información solicitada, luego se habilitara el botón...!!! </b>
      </div>
    </div>
  </div> -->
  <!-- <app-loading *ngIf="loading"></app-loading>
  <div class="row" *ngIf="!loading">
    <div class="form-group col-md-6">
      <button [routerLink]="['/distribuidor/home']" class="zatras btn btn-outline-danger btn-block btn-lg">Regresar</button>
    </div>
    <div class="form-group col-md-6">
      <button [disabled]="formulario.invalid" (click)="enviarFormulario()"
        class="zatras btn btn-success btn-block btn-lg">Enviar</button>
    </div>
  </div> -->
</div>

<div *ngIf="mostrarFormulario">
  <app-lfsa-card [innTemplate]="grid" [titulo]="'CARGAR DE ARCHIVO'" [efecto]="true" [colapseName]="'grid'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #grid>
    <!-- <div class="row">
      <div class="col-sm-12">
        <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter "
          (keyup)="onQuickFilterChanged()" #quickFilter />
      </div>
    </div> -->
    <div class="alert alert-danger" role="alert" *ngIf="listaVacia">
      No existen datos para la lista.
    </div>
    <br>
    <ag-grid-angular [floatingFilter]="true" class="{{distribuidorModulo.agGrid.class}}" #agGrid [ngStyle]="distribuidorModulo.agGrid.style"
      id="{{distribuidorModulo.agGrid.id}}" [paginationPageSize]="distribuidorModulo.agGrid.paginacion"
      [pagination]="true" [frameworkComponents]="frameworkComponents" [columnDefs]="columnDefs"
      [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </ng-template>
  <div class="row">
    <div class="form-group col-md-6">
      <button (click)="regresar()" class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
    </div>
    <div class="form-group col-md-6">
      <button [disabled]="!errorData" (click)="guardar()"
        class="btn btn-outline-success btn-block btn-lg">Guardar</button>
    </div>
  </div>
  <br>
  <br>
</div>

<!-- MODAL -->
<app-lfsa-modal [innTemplate]="abrirModalMuiltiples" [titulo]="'visualización'" [idButton]="'abrirModal'"
  [idOpen]="'ModalMultiple'" [idClose]="'cerrarModalMultiple'"></app-lfsa-modal>
<ng-template #abrirModalMuiltiples>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4">
        <b><h5>Cod.Cliente Dis:</h5></b> {{ dataRuta.codigoClienteDistribuidor }}
      </div>
      <div class="col-md-4">
        <b><h5>Cod.Cliente Fab:</h5></b> {{ dataRuta.codigoClienteFabril }}
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-3">
        <b><h5>Dia Visita:</h5></b> {{ dataRuta.diaVisita }}
      </div>
      <div class="col-md-3">
        <b><h5>Frecuencia Visita:</h5></b> {{ dataRuta.frecuenciaVisita }}
      </div>
      <div class="col-md-3">
        <b><h5>Secuencia Visita:</h5></b> {{ dataRuta.secuenciaVisita }}
      </div>
      <div class="col-md-3">
        <b><h5>Semana Visita:</h5></b> {{ dataRuta.semanaVisita }}
      </div>
    </div>
  </div>
</ng-template>
<!-- END MODAL -->
